export default function SkillsLearned() {
  const skills = [
    { icon: 'ri-vip-diamond-line', title: 'Продажа ценности' },
    { icon: 'ri-question-answer-line', title: 'Работа с возражениями' },
    { icon: 'ri-voiceprint-line', title: 'Активное слушание' },
    { icon: 'ri-phone-line', title: 'Телефонные переговоры' },
    { icon: 'ri-user-voice-line', title: 'Переговоры' },
    { icon: 'ri-focus-2-line', title: 'Метод СПИН' },
    { icon: 'ri-presentation-line', title: 'Презентация продукта' },
    { icon: 'ri-check-double-line', title: 'Закрытие сделки' },
    { icon: 'ri-funds-line', title: 'Работа с ценой' },
    { icon: 'ri-add-circle-line', title: 'Допродажи и кросс-продажи' },
    { icon: 'ri-chat-1-line', title: 'Продажи через переписку' },
    { icon: 'ri-heart-line', title: 'Удержание клиентов' },
    { icon: 'ri-search-eye-line', title: 'Выявление потребностей' },
    { icon: 'ri-line-chart-line', title: 'Работа с воронкой продаж' },
    { icon: 'ri-shield-check-line', title: 'Работа с сомнениями клиента' },
    { icon: 'ri-user-search-line', title: 'Квалификация лидов' },
    { icon: 'ri-file-list-3-line', title: 'Разработка скриптов' },
    { icon: 'ri-bar-chart-box-line', title: 'Аналитика и KPI' },
    { icon: 'ri-computer-line', title: 'Работа в CRM' },
    { icon: 'ri-timer-line', title: 'Управление временем' },
    { icon: 'ri-emotion-happy-line', title: 'Эмоциональный интеллект' },
    { icon: 'ri-lightbulb-line', title: 'Креативные продажи' },
    { icon: 'ri-team-line', title: 'Командное взаимодействие' },
    { icon: 'ri-brain-line', title: 'Стратегическое мышление' },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Чему научатся сотрудники после <strong>тренинга по продажам</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Каждый навык отрабатывается на реальных кейсах компании. Участники выходят не с теорией, а с конкретными инструментами, которые применяют на следующий же день.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {skills.map((skill, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-4 hover:bg-teal-50 hover:shadow-sm transition-all duration-200 group cursor-default flex items-center gap-3">
              <div className="w-9 h-9 bg-white rounded-lg flex items-center justify-center shadow-sm group-hover:bg-teal-600 transition-colors duration-200 flex-shrink-0">
                <i className={`${skill.icon} text-sm text-teal-600 group-hover:text-white transition-colors duration-200`}></i>
              </div>
              <span className="text-sm font-medium text-gray-800 group-hover:text-teal-700 transition-colors">{skill.title}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}